import React, { useContext } from "react";
import { AuthContext } from "./AuthContext";

export default function useAuthentication() {
  return useContext(AuthContext);
}